<template>
  <div
    class="company-facilities-counts"
    :class="{ 'company-facilities-counts--quota': showQuota }"
  >
    <template v-if="!showNotOwnedCount">
      <template v-if="showQuota">
        <IsOwnerIndicator :is-owner="true" height="22px" />
        <SubscriptionUsage
          :subscription-summary="subscriptionSummary"
          compact
        />
      </template>
      <FacilitiesCount v-else :is-owner="true" :company="companyData" />
    </template>
    <template v-else>
      <FacilitiesCount
        :is-owner="true"
        :company="companyData"
        :class="{ 'mx-3': !showQuota }"
      />
      <FacilitiesCount :is-owner="false" :company="companyData" />
      <template v-if="showQuota">
        <span aria-hidden="true">·</span>
        <SubscriptionUsage
          :subscription-summary="subscriptionSummary"
          compact
        />
      </template>
    </template>
  </div>
</template>

<script>
import FacilitiesCount from "./FacilitiesCount.vue";
import IsOwnerIndicator from "./IsOwnerIndicator.vue";
import SubscriptionUsage from "@/components/Payments/SubscriptionUsage.vue";
import { AccountType } from "@/enums/account-type";

export default {
  components: { FacilitiesCount, IsOwnerIndicator, SubscriptionUsage },
  props: { company: { type: Object, default: null } },
  computed: {
    isCurrentCompany() {
      return (
        !this.company ||
        this.company.id === this.$store.getters["company/companyId"]
      );
    },
    companyData() {
      return this.isCurrentCompany
        ? this.$store.state.company.company
        : this.company;
    },
    counts() {
      return this.companyData.company_user.facilities_access_count;
    },
    showNotOwnedCount() {
      return this.counts.not_owner > 0;
    },
    subscriptionSummary() {
      return this.isCurrentCompany
        ? this.$store.getters["company/subscriptionSummary"]
        : this.companyData.subscription_quota;
    },
    showQuota() {
      return (
        Boolean(this.subscriptionSummary) &&
        [AccountType.OWNER, AccountType.ADMIN].includes(
          this.companyData.company_user.type
        )
      );
    }
  }
};
</script>

<style scoped>
.company-facilities-counts {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.company-facilities-counts--quota {
  gap: 8px;
}
</style>
